import { Component, OnInit, Input, OnDestroy, OnChanges, HostListener, ElementRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DevicesDevicesService } from 'src/app/services/devices-services/devices-devices-services/devices-devices.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { ActivatedRoute } from '@angular/router';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { EMPTY, Subscription } from 'rxjs';
import { DevicePeripheral } from 'src/app/models/device-models/device-peripheral-model/device-peripheral.model';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-device-peripheral-info-card',
  templateUrl: './device-peripheral-info-card.component.html',
  styleUrls: ['./device-peripheral-info-card.component.scss']
})
export class DevicePeripheralInfoCardComponent implements OnInit, OnDestroy, OnChanges {

  @Input() peripheralTypes;
  @Input() peripheralConnectionTypes;
  @Input() peripheralInfo: DevicePeripheral;
  deviceInternalId;
  updatePeripheralSubscription: Subscription;
  editingLocked: boolean;
  actionList = [{ id: 'PUSH', value: 'PUSH' }, { id: 'RETURN', value: 'RETURN' }, { id: 'NEXTLOCATION', value: 'NEXTLOCATION' }, { id: 'RESET', value: 'RESET' }];
  basicDataForm = new FormGroup({
    active: new FormControl({value: true, disabled: true }),
    peripheralName: new FormControl({value: null, disabled: true }, Validators.required),
    peripheralType: new FormControl({value: null, disabled: true }, Validators.required),
    peripheralConnectionType: new FormControl({value: null, disabled: true }, Validators.required),
    connectionPort: new FormControl({value: null, disabled: true }),
    vendorId: new FormControl({value: null, disabled: true }),
    productId: new FormControl({value: null, disabled: true }),
    ip: new FormControl({value: null, disabled: true }),
    btName: new FormControl({value: null, disabled: true }),
    mac: new FormControl({value: null, disabled: true }),
    password: new FormControl({value: null, disabled: true }),
    baud: new FormControl({value: null, disabled: true })
  });
  constructor(private eRef: ElementRef,
    private devicesDevicesService: DevicesDevicesService,
    private userStorageService: UserStorageService,
    private activatedRoute: ActivatedRoute,
    private snackbarService: SnackBarService) {
    this.deviceInternalId = this.activatedRoute.snapshot.params['deviceid'];
    this.editingLocked = true;
  }

  ngOnInit() { }

  ngOnChanges() {
    if (this.peripheralInfo) {
      this.resetForm();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
      // Dentro del componente
    } else {
      // Fuera del componente
      if (event.path[0].className !== 'mat-option-text') {
        if (this.peripheralInfo && !this.editingLocked) {
          this.resetForm();
          this.editingLocked = true;
          this.basicDataForm.get('active').disable();
          this.basicDataForm.get('peripheralName').disable();
          this.basicDataForm.get('connectionPort').disable();
          this.basicDataForm.get('vendorId').disable();
          this.basicDataForm.get('productId').disable();
          this.basicDataForm.get('ip').disable();
          this.basicDataForm.get('btName').disable();
          this.basicDataForm.get('mac').disable();
          this.basicDataForm.get('password').disable();
          this.basicDataForm.get('baud').disable();
        }
      }
    }
  }

  public toggleEdition() {
    if (this.editingLocked) {
      this.editingLocked = false;
      this.basicDataForm.get('active').enable();
      this.basicDataForm.get('peripheralName').enable();
      this.basicDataForm.get('peripheralType').enable();
      this.basicDataForm.get('peripheralConnectionType').enable();
      this.basicDataForm.get('connectionPort').enable();
      this.basicDataForm.get('vendorId').enable();
      this.basicDataForm.get('productId').enable();
      this.basicDataForm.get('ip').enable();
      this.basicDataForm.get('btName').enable();
      this.basicDataForm.get('mac').enable();
      this.basicDataForm.get('password').enable();
      this.basicDataForm.get('baud').enable();
    } else {
      this.editingLocked = true;
      this.basicDataForm.get('active').disable();
      this.basicDataForm.get('peripheralName').disable();
      this.basicDataForm.get('peripheralType').disable();
      this.basicDataForm.get('peripheralConnectionType').disable();
      this.basicDataForm.get('connectionPort').disable();
      this.basicDataForm.get('vendorId').disable();
      this.basicDataForm.get('productId').disable();
      this.basicDataForm.get('ip').disable();
      this.basicDataForm.get('btName').disable();
      this.basicDataForm.get('mac').disable();
      this.basicDataForm.get('password').disable();
      this.basicDataForm.get('baud').disable();
      this.submitForm();
    }
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      active: this.peripheralInfo.Active,
      mac: this.peripheralInfo.BtMac,
      btName: this.peripheralInfo.BtName,
      password: this.peripheralInfo.BtPassword,
      baud: this.peripheralInfo.ComBaud,
      connectionPort: this.peripheralInfo.PeripheralConnectionPort,
      peripheralConnectionType: this.peripheralInfo.PeripheralConnectionType,
      peripheralName: this.peripheralInfo.PeripheralName,
      peripheralType: this.peripheralInfo.PeripheralType,
      productId: this.peripheralInfo.ProductId,
      ip: this.peripheralInfo.TcpIp,
      vendorId: this.peripheralInfo.VendorId
    });
  }

  public submitForm() {
    this.updatePeripheralSubscription = this.devicesDevicesService.savePeripheral(this.basicDataForm.get('active').value, this.peripheralInfo.InternalId, this.deviceInternalId, this.basicDataForm.get('peripheralName').value, this.basicDataForm.get('peripheralType').value, this.basicDataForm.get('peripheralConnectionType').value, this.basicDataForm.get('connectionPort').value, this.basicDataForm.get('vendorId').value, this.basicDataForm.get('productId').value, this.basicDataForm.get('baud').value, this.basicDataForm.get('btName').value, this.basicDataForm.get('mac').value, this.basicDataForm.get('password').value, this.basicDataForm.get('ip').value).pipe(
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  ngOnDestroy() {
    if (this.updatePeripheralSubscription) { this.updatePeripheralSubscription.unsubscribe(); }
  }
}
